import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PromisePool } from 'es6-promise-pool';
import { ModalBody } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  deleteCollectionFromCollectionsList,
  clearSelectedCollections,
} from '../actions/Collections';
import {
  removeFilesFromFilesList,
  clearSelectedFiles,
} from '../actions/Files';

import {
  APIupdateCollection,
  APImoveFilesToCollection,
  APIgetCollection,
} from '../api/Collections';

import { eventDispatch } from '../helpers/Events';
import { addFlashMessage } from '../helpers/FlashMessages';

import ErrorBoundary from './ErrorBoundary';

class MoveItemsModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      movedCollections: 0,
      movedFiles: 0,
    };
  }

  componentDidMount() {
    this.moveItems();
  }

  getCollectionsPromisePool() {
    const {
      dispatch,
      collections,
      targetCollectionUuid,
    } = this.props;

    let counterCollections = 0;
    const promiseProducerCollections = () => {
      if (counterCollections < collections.length) {
        const collection = {
          uuid: collections[counterCollections],
        };
        collection.parent_uuid = targetCollectionUuid;
        counterCollections += 1;
        return APIupdateCollection({ collection }).then(() => {
          eventDispatch('collectionUpdatedTree', collection);
          dispatch(deleteCollectionFromCollectionsList(collection));
          this.setState({ movedCollections: counterCollections });
        });
      }
      return null;
    };

    return new PromisePool(promiseProducerCollections, 2);
  }

  getFilesPromisePool() {
    const {
      dispatch,
      files,
      targetCollectionUuid,
      currentCollectionUuid,
    } = this.props;

    let counterFiles = 0;
    const promiseProducerFiles = () => {
      if (counterFiles < files.length) {
        const file = files[counterFiles];
        counterFiles += 1;
        return APImoveFilesToCollection(targetCollectionUuid, {
          files: [file],
          sourceCollectionUuid: currentCollectionUuid,
        }).then(() => {
          dispatch(removeFilesFromFilesList([{ uuid: file }]));
          this.setState({ movedFiles: counterFiles });
        });
      }
      return null;
    };

    return new PromisePool(promiseProducerFiles, 2);
  }

  showProgress() {
    const {
      collections,
      files,
    } = this.props;
    const {
      movedCollections,
      movedFiles,
    } = this.state;

    const total = collections.length + files.length;
    const percentage = ((movedCollections + movedFiles) / total) * 100;

    return ` (${Math.round(percentage)}%)`;
  }

  finishMoving() {
    const {
      intl,
      dispatch,
      targetCollectionUuid,
      handleClose,
    } = this.props;

    let targetCollectionSlug = targetCollectionUuid;
    if (!targetCollectionSlug) {
      targetCollectionSlug = '';
    }

    dispatch(clearSelectedCollections());
    dispatch(clearSelectedFiles());
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'Assets have been moved',
      }),
      button: {
        url: `/collections/${targetCollectionSlug}`,
        text: 'Open Collection',
      },
    });
    handleClose();
  }

  moveItems() {
    const { targetCollectionUuid } = this.props;

    const promises = [].concat(this.getCollectionsPromisePool().start())
      .concat(this.getFilesPromisePool().start());
    Promise.all(promises).then(() => {
      if (!targetCollectionUuid || targetCollectionUuid === 'all' || targetCollectionUuid === '-1') {
        this.finishMoving();
      } else {
        APIgetCollection(targetCollectionUuid).then((response) => {
          eventDispatch('collectionUpdated', response.data);
          this.finishMoving();
        });
      }
    });
  }

  render() {
    const {
      intl,
      collections,
      files,
    } = this.props;

    const responseText = {
      collectionsText: collections.length > 0 ? intl.formatMessage({
        defaultMessage: '{count} {count, plural, one {collection} other {collections}}',
      }, {
        count: collections.length,
      }) : '',
      filesText: files.length ? intl.formatMessage({
        defaultMessage: '{count} {count, plural, one {file} other {files}}',
      }, {
        count: files.length,
      }) : '',
    };

    return (
      <ErrorBoundary>
        <ModalBody>
          <div className="center">
            <h5>
              {
                intl.formatMessage({
                  defaultMessage: 'Moving {collectionsText}{count, plural, one {} other { and }}{filesText}',
                }, {
                  collectionsText: responseText.collectionsText,
                  filesText: responseText.filesText,
                  count: (collections.length > 0 && files.length > 0) ? 2 : 1,
                })
              }
              {this.showProgress()}
            </h5>
            <div className="move-icon">
              <i className="fas fa-arrow-alt-right fa-2xl" />
            </div>
          </div>
        </ModalBody>
      </ErrorBoundary>
    );
  }
}

MoveItemsModal.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  targetCollectionUuid: PropTypes.string,
  currentCollectionUuid: PropTypes.string,
  collections: PropTypes.array.isRequired,
  files: PropTypes.array,
};

MoveItemsModal.defaultProps = {
  targetCollectionUuid: null,
  currentCollectionUuid: null,
  files: [],
};

export default connect()(injectIntl(MoveItemsModal));
